import React, { useContext } from "react";
import Footer from "../../components/Footer"
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { Header } from "../../components/Header";
import { PaginatorContext } from "../../providers/Paginator";
import Loading from "../../components/Loading";
import RouteTitleManager from "../../utils/RouteTitleManager";
import { DrawerContext } from "../../components/navbar/DrawerContext";
import useEventoStore from "../../stores/useEventoStore";
import { useMediaQuery } from "react-responsive";

export const Layout = ({ children }) => {
  const { setEvent } = useContext(PaginatorContext)
  const param = useParams();
  const [loading, setLoading] = useState(() => !useEventoStore.getState().getEvento(param.id));
  const { setDrawerLoading, drawerOpen } = useContext(DrawerContext);
  const { fetchEvento } = useEventoStore();
    const isMobile = useMediaQuery({ query: `(max-width: 770px)` });
  const eventoData = useEventoStore(
    (state) => state.eventosPorId[param.id]?.data ?? null
  );

  useEffect(() => {
    const load = async () => {
      setDrawerLoading(true);
      try {
        const data = await fetchEvento(param.id);
        if (data?.evento) {
          await setEvent(data.evento.evento);
        }
      } finally {
        setLoading(false);
        setDrawerLoading(false);
      }
    };
    load();
  }, [param.id]);

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <RouteTitleManager />
      <div className="body d-flex" style={{ height: "100%" }}>
        <div style={{
          flex: "1 1 0%",
          minWidth: 0,
          marginLeft: isMobile ? '0' : (drawerOpen ? '0' : '64px'),
          transition: "margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        }}>
          {eventoData?.evento && (
            <div className="h-100 d-flex flex-column">
              <Header evento={eventoData.evento} />
              <div className="flex-grow-1">
                {children}
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  )
}

export default Layout;